import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getCountries} from '../../services';
import {ICountryFilter, ICountryRes, ICountryState} from "../types/ICountry";
import {AppState} from "./rootReducer";

const initialState: ICountryState = {
    status: "idle"
}

export const mostrarCountries = createAsyncThunk(
    'mostrarCountries', async (params:ICountryFilter|undefined, thunkAPI ) => {
        const {countries} = thunkAPI.getState() as AppState;
        let paramsFilter = params || countries.filtered;

        const response = await getCountries(paramsFilter)
        return {data: response.data as ICountryRes, params: response.config.params}
    }
)
export const mostrarCountriesSinoEsta = createAsyncThunk(
    'mostrarCountriesSinoEsta', async (_,thunkAPI) => {
        let countries = (thunkAPI.getState() as AppState)?.countries;
        if (!!countries?.list?.items.length || countries.status === "loading") return false;

        return thunkAPI.dispatch(mostrarCountries());

    }
)


const slice = createSlice({
    name: 'mostrarCountries',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarCountries
        builder.addCase(mostrarCountries.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarCountries.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarCountries.rejected, (state ) => {
            state.status = "idle";
        })

    }
});

export default slice.reducer;
